export const components = [
  'heroCarousel',
  'welcomeMessage',
  'ArticleGuides',
  'BuyItAgain',
  'ComponentSelector',
  'HDCC',
  'Hero',
  'HeroCarousel',
  'HomepageHero',
  'LatestOrder',
  'Loyalty',
  'Media',
  'MyList',
  'MyQuotes',
  'OnlineWorkshopsMetadata',
  'PersonalizedHomeServices',
  'PopularCategories',
  'ProjectGuides',
  'PromotionalProducts',
  'PromotionalNavigation',
  'RecentlyViewed',
  'RecentOrderHistory',
  'Recommendations',
  'ResourcesSection',
  'Section',
  'SBOTW',
  'ShopByCategory',
  'SignIn',
  'SpecialBuyOfTheDay',
  'SponsoredBanner',
  'Spotlight',
  'TodaysRecommendations',
  'TopCategories',
  'TopSavings',
  'TrendingInYourNeighborhood',
  'VisualNavigation',
  'YourStore',
];

// Component dictionary has min/max;
/**
 * Section vs Grid
 * Ordering taking precedence over x,y
 */

export const DEFAULT_SIZES = {
  minWidthMedium: {
    min: 12,
    max: 12,
  },
  minWidthLarge: {
    min: 4,
    max: 4,
  },
};

const HeroMetadata = {
  sizes: {
    minWidthMedium: {
      min: 12,
      max: 12,
    },

    minWidthLarge: {
      min: 8,
      max: 12,
    },
  },
};

const HeroCarouselMetadata = {
  sizes: {
    minWidthMedium: {
      min: 12,
      max: 12,
    },

    minWidthLarge: {
      min: 8,
      max: 12,
    },
  },
};

const heroCarouselMetadata = {
  sizes: {
    minWidthMedium: {
      min: 12,
      max: 12,
    },

    minWidthLarge: {
      min: 4,
      max: 12,
    },
  },
};

const HomepageHeroMetadata = {
  sizes: {
    minWidthMedium: {
      min: 12,
      max: 12,
    },

    minWidthLarge: {
      min: 8,
      max: 12,
    },
  },
};

const LoyaltyMetadata = {
  sizes: {
    minWidthMedium: {
      min: 6,
      max: 6,
    },

    minWidthLarge: {
      min: 4,
      max: 4,
    },
  },
};

const RecentOrderHistoryMetadata = {
  sizes: {
    minWidthMedium: {
      min: 6,
      max: 12,
    },

    minWidthLarge: {
      min: 4,
      max: 4,
    },
  },
};

const LatestOrderMetadata = {
  sizes: {
    minWidthMedium: {
      min: 6,
      max: 12,
    },

    minWidthLarge: {
      min: 4,
      max: 4,
    },
  },
};

const MyListMetadata = {
  sizes: {
    minWidthMedium: {
      min: 6,
      max: 12,
    },

    minWidthLarge: {
      min: 4,
      max: 4,
    },
  },
};

const RecentlyViewedMetadata = {
  sizes: {
    minWidthMedium: {
      min: 6,
      max: 12,
    },

    minWidthLarge: {
      min: 4,
      max: 12,
    },
  },
};

const BuyItAgainMetadata = {
  sizes: {
    minWidthMedium: {
      min: 6,
      max: 12,
    },

    minWidthLarge: {
      min: 4,
      max: 12,
    },
  },
};

const MyQuotesMetadata = {
  sizes: {
    minWidthMedium: {
      min: 6,
      max: 12,
    },

    minWidthLarge: {
      min: 4,
      max: 4,
    },
  },
};

const HDCCMetadata = {
  sizes: {
    minWidthMedium: {
      min: 6,
      max: 6,
    },

    minWidthLarge: {
      min: 4,
      max: 4,
    },
  },
};

const TopCategoriesMetadata = {
  sizes: {
    minWidthMedium: {
      min: 6,
      max: 12,
    },

    minWidthLarge: {
      min: 4,
      max: 12,
    },
  },
};

const TopSavingsMetadata = {
  sizes: {
    minWidthMedium: {
      min: 12,
      max: 12,
    },

    minWidthLarge: {
      min: 12,
      max: 12,
    },
  },
};

const TodaysRecommendationsMetadata = {
  sizes: {
    minWidthMedium: {
      min: 6,
      max: 12,
    },

    minWidthLarge: {
      min: 4,
      max: 12,
    },
  },
};

const MarketingMetadata = {
  sizes: {
    minWidthMedium: {
      min: 12,
      max: 12,
    },

    minWidthLarge: {
      min: 4,
      max: 12,
    },
  },
};

const SpecialBuyOfTheDayMetadata = {
  sizes: {
    minWidthMedium: {
      min: 12,
      max: 12,
    },

    minWidthLarge: {
      min: 12,
      max: 12,
    },
  },
};

const SBOTDMetadata = {
  sizes: {
    minWidthMedium: {
      min: 12,
      max: 12,
    },

    minWidthLarge: {
      min: 12,
      max: 12,
    },
  },
};

const SBOTWMetadata = {
  sizes: {
    minWidthMedium: {
      min: 12,
      max: 12,
    },

    minWidthLarge: {
      min: 12,
      max: 12,
    },
  },
};

const TrendingInYourNeighborhoodMetadata = {
  sizes: {
    minWidthMedium: {
      min: 6,
      max: 12,
    },

    minWidthLarge: {
      min: 4,
      max: 12,
    },
  },
};

const YourStoreMetadata = {
  sizes: {
    minWidthMedium: {
      min: 6,
      max: 12,
    },

    minWidthLarge: {
      min: 4,
      max: 12,
    },
  },
};

const ProjectGuidesMetadata = {
  sizes: {
    minWidthMedium: {
      min: 12,
      max: 12,
    },

    minWidthLarge: {
      min: 12,
      max: 12,
    },
  },
};

const PromotionalProductsMetadata = {
  sizes: {
    minWidthMedium: {
      min: 12,
      max: 12,
    },

    minWidthLarge: {
      min: 4,
      max: 12,
    },
  },
};

const PromotionalNavigationMetadata = {
  sizes: {
    minWidthMedium: {
      min: 12,
      max: 12,
    },

    minWidthLarge: {
      min: 4,
      max: 12,
    },
  },
};

const ResourcesSectionMetadata = {
  sizes: {
    minWidthMedium: {
      min: 12,
      max: 12,
    },

    minWidthLarge: {
      min: 4,
      max: 12,
    },
  },
};

// const SpotlightSectionMetadata = {
//   sizes: {
//     minWidthMedium: {
//       min: 6,
//       max: 12,
//     },

//     minWidthLarge: {
//       min: 4,
//       max: 12,
//     },
//   },
// };

const SponsoredBannerMetadata = {
  sizes: {
    minWidthMedium: {
      min: 12,
      max: 12,
    },

    minWidthLarge: {
      min: 12,
      max: 12,
    },
  },
};

const SpotlightMetadata = {
  sizes: {
    minWidthMedium: {
      min: 6,
      max: 12,
    },

    minWidthLarge: {
      min: 4,
      max: 12,
    },
  },
};

const MediaMetadata = {
  sizes: {
    minWidthMedium: {
      min: 6,
      max: 12,
    },

    minWidthLarge: {
      min: 4,
      max: 12,
    },
  },
};

const VisualNavigationMetadata = {
  sizes: {
    minWidthMedium: {
      min: 6,
      max: 12,
    },

    minWidthLarge: {
      min: 4,
      max: 12,
    },
  },
};

const SectionMetadata = {
  sizes: {
    minWidthMedium: {
      min: 12,
      max: 12,
    },

    minWidthLarge: {
      min: 12,
      max: 12,
    },
  },
};

const RecommendationsMetadata = {
  sizes: {
    minWidthMedium: {
      min: 6,
      max: 12,
    },

    minWidthLarge: {
      min: 4,
      max: 12,
    },
  },
};

const welcomeMessageMetadata = {
  sizes: {
    minWidthMedium: {
      min: 12,
      max: 12,
    },

    minWidthLarge: {
      min: 12,
      max: 12,
    },
  },
};

const PrivateLabelCreditCardMetadata = {
  sizes: {
    minWidthMedium: {
      min: 6,
      max: 6,
    },

    minWidthLarge: {
      min: 4,
      max: 4,
    },
  },
};

const StoreDetailsMetadata = {
  sizes: {
    minWidthMedium: {
      min: 6,
      max: 12,
    },

    minWidthLarge: {
      min: 4,
      max: 4,
    },
  },
};

const OnlineWorkshopsMetadata = {
  sizes: {
    minWidthMedium: {
      min: 6,
      max: 12,
    },

    minWidthLarge: {
      min: 4,
      max: 12,
    },
  },
};

const PopularCategoriesMetadata = {
  sizes: {
    minWidthMedium: {
      min: 12,
      max: 12,
    },

    minWidthLarge: {
      min: 12,
      max: 12,
    },
  },
};

const ShopByCategoryMetadata = {
  sizes: {
    minWidthMedium: {
      min: 12,
      max: 12,
    },

    minWidthLarge: {
      min: 12,
      max: 12,
    },
  },
};

const SignInMetadata = {
  sizes: {
    minWidthMedium: {
      min: 6,
      max: 6,
    },

    minWidthLarge: {
      min: 4,
      max: 4,
    },
  },
};

const ArticleGuidesMetaData = {
  sizes: {
    minWidthMedium: {
      min: 6,
      max: 12,
    },

    minWidthLarge: {
      min: 4,
      max: 12,
    },
  },
};

const PersonalizedHomeServicesMetaData = {
  sizes: {
    minWidthMedium: {
      min: 12,
      max: 12,
    },

    minWidthLarge: {
      min: 8,
      max: 12,
    },
  },
};

const ComponentMetadata = {
  ArticleGuidesMetaData,
  BuyItAgainMetadata,
  HDCCMetadata,
  HeroMetadata,
  HeroCarouselMetadata,
  heroCarouselMetadata,
  HomepageHeroMetadata,
  LatestOrderMetadata,
  LoyaltyMetadata,
  MarketingMetadata,
  MediaMetadata,
  MyListMetadata,
  MyQuotesMetadata,
  OnlineWorkshopsMetadata,
  PopularCategoriesMetadata,
  PrivateLabelCreditCardMetadata,
  ProjectGuidesMetadata,
  PromotionalNavigationMetadata,
  PromotionalProductsMetadata,
  PersonalizedHomeServicesMetaData,
  RecentOrderHistoryMetadata,
  RecentlyViewedMetadata,
  RecommendationsMetadata,
  ResourcesSectionMetadata,
  SBOTWMetadata,
  SectionMetadata,
  ShopByCategoryMetadata,
  SpecialBuyOfTheDayMetadata,
  SponsoredBannerMetadata,
  SpotlightMetadata,
  StoreDetailsMetadata,
  TodaysRecommendationsMetadata,
  TopCategoriesMetadata,
  TopSavingsMetadata,
  TrendingInYourNeighborhoodMetadata,
  VisualNavigationMetadata,
  welcomeMessageMetadata,
  YourStoreMetadata,
  SignInMetadata
};

export const componentsWithDefaultAspectRatios = { 'Hero Carousel': true };

export default ComponentMetadata;
